export default __webpack_public_path__ + "static/media/mastercard.a3cbcb07.svg";